/// <amd-module name="Analytics/Shared/Common/Service/AnalyticsHubBreadCrumbService" />
import * as Resources from "Analytics/Shared/Common/Resources";
import { IAnalyticsDataService } from "Analytics/Shared/Common/Types";
import { getContextTypeFromUrl } from "Analytics/Shared/Utils/URLHelper";
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { onClickFPS } from "VSS/Platform/FPS";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";
import { IVssBreadcrumbItem } from "VSSUI/VssBreadcrumb";

export class AnalyticsHubBreadCrumbService extends VssService implements IBreadcrumbItemService {
    private _analyticsDataService: IAnalyticsDataService;
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public async addDefinition(buildDefinitionId: number): Promise<void> {
        const breadCrumbItems = await this._getBreadcrumbItems(buildDefinitionId);
        breadCrumbItems.forEach(item => this.items.push(item));
    }

    public async _serviceStart(pageContext: IVssPageContext): Promise<void> {
        super._serviceStart(pageContext);
        const contextType = getContextTypeFromUrl(this.pageContext);
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        if(contextType == "build") {
            await contributionService.getContributionAsync("ms.vss-analyticsshared-web.analytics-build-service");
            this._analyticsDataService = pageContext.getService("IBuildAnalyticsDataService");
        } else {
            await contributionService.getContributionAsync("ms.vss-test-analytics-web.release-helper");
            this._analyticsDataService = pageContext.getService("IReleaseAnalyticsDataService");
        }
    }

    private async _getBreadcrumbItems(buildDefinitionId: number): Promise<IVssBreadcrumbItem[]> {
        const definitionName = await this._analyticsDataService.fetchDefinitionName(buildDefinitionId);
        const definitionUrl = this._analyticsDataService.getDefinitionUrl(buildDefinitionId);
        const analyticsCardMetricsUrl = this._analyticsDataService.getAnalyticsCardMetricsUrl(buildDefinitionId);
        return [
            {
                key: "definition-breadcrumb",
                href: definitionUrl,
                text: definitionName,
                onClick: ev => {
                    onClickFPS(this.pageContext, definitionUrl, true, ev);
                },
                ariaLabel: definitionName
            },
            {
                key: "definition-analytics-breadcrumb",
                text: Resources.AnalyticsText,
                href: analyticsCardMetricsUrl,
                onClick: ev => {
                    onClickFPS(this.pageContext, analyticsCardMetricsUrl, true, ev);
                },
                ariaLabel: Resources.AnalyticsText
            }
        ];
    }
}

Services.add("analytics-hub-breadcrumb-service", { serviceFactory: AnalyticsHubBreadCrumbService });
